module.exports = __webpack_public_path__ + "img/mac.9b463e56.png";